import React, { useMemo, useState } from 'react';

/**
 * Clamps long text with Read more / Read less.
 * Uses CSS classes from AdminPages.css.
 */
const ExpandableText = ({
  text,
  lines = 2,
  minCharsForToggle = 90,
  placeholder = '-',
}) => {
  const raw = useMemo(() => String(text || '').trim(), [text]);
  const [expanded, setExpanded] = useState(false);

  if (!raw) return <span>{placeholder}</span>;

  const showToggle = raw.length > minCharsForToggle;

  return (
    <>
      <span
        className={[
          'admin-expandable-text',
          !expanded ? 'admin-expandable-text--clamped' : '',
        ].join(' ')}
        style={{ '--line-clamp': lines }}
      >
        {raw}
      </span>
      {showToggle && (
        <button
          type="button"
          className="admin-expandable-toggle"
          onClick={() => setExpanded((v) => !v)}
        >
          {expanded ? 'Read less' : 'Read more'}
        </button>
      )}
    </>
  );
};

export default ExpandableText;

